import { render, staticRenderFns } from "./CoverDetailsPage.vue?vue&type=template&id=0c834ec4&scoped=true"
import script from "./CoverDetailsPage.vue?vue&type=script&lang=js"
export * from "./CoverDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./CoverDetailsPage.vue?vue&type=style&index=0&id=0c834ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c834ec4",
  null
  
)

export default component.exports